/**
 * Italian-locale row-count copy used in ``DisplayResultChips`` +
 * ``MessagePreviewEmbed`` table chip.
 *
 * Centralised here because the naïve template
 * ``\`${n} righ${n === 1 ? "a" : "e"}\``` produces "righa" (wrong root)
 * for the singular case — that bug was present in two call-sites until
 * June 15, 2026.
 */

const NUMBER_FORMATTER = new Intl.NumberFormat("it-IT");

export function pluralizeRows(n: number): string {
  if (n === 1) return "1 riga";
  return `${NUMBER_FORMATTER.format(n)} righe`;
}
